import { Component } from '@angular/core';
import { UIModule } from '@bannerflow/ui';
import { AppComponent } from '../../app.component';

@Component({
    imports: [UIModule],
    selector: 'studio-oops',
    templateUrl: 'oops-page.component.html',
    styleUrls: ['oops-page.component.scss']
})
export class OopsComponent {
    constructor(private app: AppComponent) {
        this.app.loaded.set(true);
    }
}
